module.exports = __webpack_public_path__ + "static/media/Delivery.f6913fe2.png";